(function () {
  "use strict";
  var REQ_KEY = "rvaThreadsRequest.v1";

  function readReq() {
    try {
      var t = JSON.parse(localStorage.getItem(REQ_KEY) || "null");
      if (!t || t.v !== 1) return null;
      if (t.at && Date.now() - t.at > 2592e6) return null;
      return t;
    } catch (e) { return null; }
  }
  function slug(v) { return String(v).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); }
  function poll(test, fn, tries) {
    if (test()) { fn(); return; }
    var n = 0, iv = setInterval(function () { if (test()) { clearInterval(iv); fn(); } else if (++n > (tries || 200)) clearInterval(iv); }, 50);
  }

  function cardsAsLinks() {
    var grid = document.getElementById("grid");
    if (!grid || document.getElementById("reqPage")) return;
    poll(function () { return typeof window.cardHTML === "function" && typeof window.render === "function" && typeof window.styleHref === "function"; }, function () {
      var o = window.cardHTML;
      if (o.rvaLinks) return;
      var w = function (s) {
        var h = o.apply(this, arguments);
        if (!s || !s.id) return h;
        var open = '<button class="card" type="button" data-id="' + s.id + '">';
        if (h.indexOf(open) !== 0) return h;
        return '<a class="card" href="' + window.styleHref(s) + '" data-id="' + s.id + '">' + h.slice(open.length).replace(/<\/button>$/, "</a>");
      };
      w.rvaLinks = 1;
      window.cardHTML = w;

      grid.addEventListener("click", function (e) {
        var dot = e.target.closest && e.target.closest(".dot");
        if (dot) { if (dot.closest("a.card")) e.preventDefault(); return; }
        var card = e.target.closest && e.target.closest("a.card");
        if (card) e.stopPropagation();
      }, true);
      try { window.render(); } catch (e) {}
    });
  }

  function filterBits() {
    var S = window.S, bits = [];
    if (!S) return bits;
    function on(o) { return Object.keys(o || {}).filter(function (k) { return o[k]; }); }
    if (S.yv && S.yv.youth) bits.push("type=youth");
    else if (S.wv && S.wv.womens) bits.push("type=womens");
    on(S.type).forEach(function (k) { bits.push("type=" + slug(k)); });
    on(S.brand).forEach(function (k) { bits.push("brand=" + slug(k)); });
    on(S.fam).forEach(function (k) { bits.push("fam=" + slug(k)); });
    on(S.fab).forEach(function (k) { bits.push("fab=" + slug(k)); });
    on(S.weight).forEach(function (k) { bits.push("weight=" + slug(k)); });
    return bits;
  }
  function catalogLink() {
    var S = window.S || {}, bits = ["front=" + (S.front || 0)];
    if (S.back) bits.push("back=" + S.back);
    bits.push("qty=" + (S.qty || 12));
    return location.origin + "/pages/screen-printing-pricing-calculator#" + bits.concat(filterBits()).join("&");
  }
  function copyLinkWithFilters() {
    if (!document.getElementById("bar")) return;
    poll(function () { return !!document.getElementById("barCopy") && typeof window.copyText === "function"; }, function () {
      var b = document.getElementById("barCopy");
      if (b.dataset.rvaFilters) return;
      var c = b.cloneNode(true);
      c.dataset.rvaFilters = "1";
      c.title = "Copy a link to the catalog with these specs and filters";
      c.addEventListener("click", function () { window.copyText(catalogLink(), c, "Link copied"); });
      b.parentNode.replaceChild(c, b);
    });
  }

  function homePicker() {
    var band = document.querySelector(".rva-bl__band");
    var qtyIn = document.getElementById("rvaBlQtyIn"), inkStep = document.getElementById("rvaBlInk");
    var backOn = document.getElementById("rvaBlBackOn"), backStep = document.getElementById("rvaBlBack");
    var grid = document.getElementById("rvaBlGrid");
    if (!band || !qtyIn || !inkStep || !backOn || !backStep) return;
    function num(t) { var m = String(t || "").match(/\d+/); return m ? +m[0] : 0; }
    function current() {
      var on = backOn.getAttribute("aria-pressed") === "true";
      return {
        qty: Math.max(12, Math.min(5000, parseInt(qtyIn.value, 10) || 12)),
        front: num((document.getElementById("rvaBlInkVal") || {}).textContent),
        back: on ? Math.max(1, num((document.getElementById("rvaBlBackVal") || {}).textContent)) : 0
      };
    }
    function specHash(c) { return "#front=" + c.front + (c.back ? "&back=" + c.back : "") + "&qty=" + c.qty; }
    function carry() {
      var c = current(), sec = band.closest(".rva-bl") || document;
      Array.prototype.forEach.call(sec.querySelectorAll("a.rva-link, a.rva-bl__card"), function (a) {
        var base = a.getAttribute("data-base") || (a.getAttribute("href") || "").split("#")[0];
        if (!base) return;
        a.setAttribute("data-base", base);
        a.setAttribute("href", base + specHash(c));
      });
    }
    function save() {
      var c = current();
      try {
        var t = readReq() || { v: 1, lines: [], exempt: false };
        t.v = 1; t.at = Date.now(); t.qty = c.qty; t.front = c.front; t.back = c.back;
        localStorage.setItem(REQ_KEY, JSON.stringify(t));
      } catch (e) {}
      carry();
    }
    function press(el) { if (el && !el.disabled) el.click(); }
    function apply(t) {
      var guard = 0, c;
      if (t.qty && Math.max(12, Math.min(5000, +t.qty)) !== current().qty) {
        qtyIn.value = Math.max(12, Math.min(5000, +t.qty));
        qtyIn.dispatchEvent(new Event("input", { bubbles: true }));
      }
      var wantBack = t.back ? Math.max(1, Math.min(8, +t.back)) : 0;
      var wantFront = t.front != null ? Math.max(0, Math.min(8, +t.front)) : 1;
      if (!wantBack && !wantFront) wantFront = 1;
      if (!!wantBack !== (backOn.getAttribute("aria-pressed") === "true")) press(backOn);
      while (wantBack && (c = current()).back < wantBack && guard++ < 12) press(backStep.querySelector('[data-d="1"]'));
      guard = 0;
      while ((c = current()).front < wantFront && guard++ < 12) press(inkStep.querySelector('[data-d="1"]'));
      guard = 0;
      while ((c = current()).front > wantFront && guard++ < 12) {
        var minus = inkStep.querySelector('[data-d="-1"]');
        if (!minus || minus.disabled) break;
        press(minus);
      }
    }
    var saved = readReq();
    if (saved && (saved.qty || saved.front != null || saved.back)) apply(saved);
    carry();
    var queued = false;
    function soon() {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; save(); }, 0);
    }
    band.addEventListener("click", soon);
    band.addEventListener("input", soon);
    band.addEventListener("change", soon);
    if (grid && "MutationObserver" in window) new MutationObserver(function () { carry(); }).observe(grid, { childList: true });
  }

  function fitSuggestions() {
    var input = document.getElementById("q"), host = input && input.parentNode;
    if (!host) return;
    var busy = false;
    function refit() {
      if (busy) return;
      var panel = host.querySelector(".rvaSug");
      if (!panel || panel.hidden) return;
      var vw = Math.min(window.innerWidth, document.documentElement.clientWidth, (window.screen && screen.width) || 1e9);
      if (!(vw > 0) || vw > 749) return;
      var w = (vw - 16) + "px", l = Math.round(8 - host.getBoundingClientRect().left) + "px";
      if (panel.style.width === w && panel.style.left === l) return;
      busy = true;
      panel.style.width = w;
      panel.style.left = l;
      busy = false;
    }
    input.addEventListener("input", function () { setTimeout(refit, 0); });
    window.addEventListener("resize", function () { setTimeout(refit, 0); });
    if ("MutationObserver" in window) new MutationObserver(function () { refit(); }).observe(host, { attributes: true, childList: true, subtree: true });
  }

  function start() {
    cardsAsLinks();
    copyLinkWithFilters();
    homePicker();
    fitSuggestions();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
